<template>
  <div class="main">
    <el-card class="cpProfile">
      <div slot="header" class="clearfix">
        <span style="font-size: 26px">公司简介</span>
        <span class="en-title">Company Profile</span>
      </div>
      <div class="text item" style="white-space: pre-wrap;line-height:32px;">{{introduction}}</div>
      <div class="block">
        <el-carousel trigger="click"
        height="500px"
        style="border-radius: 20px;"
        :autoplay="isAutoPlay"
        @mouseenter.native="isAutoPlay = false"
        @mouseleave.native="isAutoPlay = true">
          <el-carousel-item v-for="(item, index) in listImgs" :key="index">
            <el-image style="width: 100%; height: 100%" fit="cover" :src="item.imgUrl"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-card>
    <el-card class="comp-ry">
      <div slot="header" class="clearfix">
        <span style="font-size: 26px">公司荣誉</span>
        <span class="en-title">Company Honors</span>
      </div>
      <el-row :gutter="30">
        <el-col :span="6"><div class="grid-content bg-purple">
          <el-card class="slogan">
            <el-image style="width: 384px; height: 160px" :src="sloganImg" fit="cover"></el-image>
            <div style="width:390px">{{sloganDetail}}</div>
          </el-card>
        </div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple" @click="ryImgAll">
        <div class="image-slider">
          <vue-seamless-scroll
            class="scroll-container"
            :data="ryImgs"
            :class-option="optionLeft">
            <ul class="imgScroll">
              <li v-for="(item, index) in ryImgs" :key="index">
                <img :src="item.imgUrl">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
        </div></el-col>
      </el-row>
      <div id="business-ym"></div>
    </el-card>
    <el-card class="comp-yw">
      <div slot="header" class="clearfix">
        <span style="font-size: 26px">业务合作</span>
        <span class="en-title">Business Cooperation</span>
      </div>
      <el-image style="width: 700px; height: 620px; border-radius: 20px" :src="oemImg" fit="cover"></el-image>
      <div class="yw-block">
        <el-carousel trigger="click"
        height="620px"
        style="border-radius: 20px;"
        :autoplay="isAutoPlay"
        @mouseenter.native="isAutoPlay = false"
        @mouseleave.native="isAutoPlay = true">
          <el-carousel-item v-for="(item, index) in dgImgs" :key="index">
            <el-image style="width: 100%; height: 100%" fit="cover" :src="item.imgUrl"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <el-button @click="oemShow = !oemShow" class="btn-oem" style="width:120px">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <i class="el-icon-right el-icon--right" style="color: rgb(64, 158, 255); font-size: 20px"></i></el-button> -->
    </el-card>
    <!-- <el-dialog title="OEM介绍" :visible.sync="oemShow" width="1250px" top="50px">
      <el-image :src="oemDetail" fit="cover"></el-image>
    </el-dialog> -->
    <el-card class="dpHis">
      <div slot="header" class="clearfix">
        <span style="font-size: 26px">发展历程</span>
        <span class="en-title">Development History</span>
      </div>
      <el-timeline>
        <el-timeline-item placement="top"
          v-for="(activity, index) in activities"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :timestamp="activity.timestamp"
          style="font-size: 16px;">
          <el-card>
            <span style="font-weight:600">{{activity.title}}</span>
            <p>{{activity.content}}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-card>
    <el-drawer title="知识产权" style="font-size:20px;" :visible.sync="ryImgShow" direction="rtl" size="680px">
      <el-card style="width:680px; margin-bottom:20px;">
            <span style="font-weight:600; font-size:17px;">{{ryInfo.ryTotal}}</span><br>
            <!-- <div style="text-align: left;">
              <span style="font-size:16px;">{{ryInfo.ryNow}}</span><br>
              <span style="font-size:16px;">{{ryInfo.ryFu}}</span>
            </div> -->
      </el-card>
      <div class="product-card">
        <el-input placeholder="请输入名称" prefix-icon="el-icon-search" v-model="searchStr" @change="rySearch" clearable>
          <el-button slot="append" icon="el-icon-search" @click="rySearch"></el-button>
          <el-button slot="append" icon="el-icon-refresh" @click="clearSearch"></el-button>
        </el-input>
        <el-table
          ref="filterTable"
          :data="pageList"
          stripe
          style="width: 100%"
          height="735"
          @row-click="rySelect">
          <el-table-column
            label="序号"
            type="index"
            align="center"
            :index="1"
            width="50">
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            align="center"
            width="260"
          >
          </el-table-column>
          <el-table-column
            prop="category"
            align="center"
            label="类型"
            width="150"
            :filters="[{text: '发明专利', value: '发明专利'}, {text: '实用新型', value: '实用新型'}, {text: '外观设计', value: '外观设计'}, {text: '软件著作', value: '软件著作'}]"
            :filter-method="filterHandler">
          </el-table-column>
          <el-table-column
            prop="releaseDate"
            align="center"
            label="授权公告日期"
            width="180">
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="total"
        @current-change="pageChange"
        @prev-click="pagePrev"
        @next-click="pageNext"
        >
      </el-pagination>
    </el-drawer>
    <el-dialog
      title="证书详情"
      :visible.sync="ryImgDiaShow"
      width="600px"
      top="30px"
      center>
      <el-image :src="ryShowImgUrl" fit="cover"></el-image>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'introduction',
  data () {
    return {
      isAutoPlay: true,
      listImgs: [],
      introduction: '',
      sloganDetail: '',
      sloganImg: '',
      ryImgShow: false,
      ryShowImgUrl: '',
      oemImg: '',
      dgImgs: [],
      ryImgs: [],
      ryImgsCopy: [],
      pageList: [],
      searchStr: '',
      ryInfo: {},
      ryImgDiaShow: false,
      activities: [],
      pageNum: 1,
      pageSize: 15,
      total: 0
    }
  },
  computed: {
    optionLeft () {
      return {
        step: 0.5,
        limitMoveNum: 0,
        hoverStop: true,
        direction: 2,
        openWatch: true,
        singleWidth: 0,
        waitTime: 1000
      }
    }
  },
  mounted () {
    this.$axios.get('/static/introduct.json').then(res => {
      this.listImgs = res.data.listImgs
      this.ryImgs = res.data.ryImgs
      this.ryImgsCopy = res.data.ryImgs
      this.ryInfo = res.data.ryInfo
      this.activities = res.data.activities
      this.introduction = res.data.introduction
      this.sloganDetail = res.data.sloganDetail
      this.sloganImg = res.data.sloganImg
      this.oemImg = res.data.oemImg
      this.dgImgs = res.data.dgImgs
      this.pageNum = 1
      this.total = this.ryImgs.length
      this.pageList = this.ryImgs.slice(0, this.pageSize)
    })
  },
  methods: {
    ryImgAll () {
      this.ryImgShow = true
    },
    rySelect (row) {
      this.ryShowImgUrl = row.imgUrl
      this.ryImgDiaShow = true
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    rySearch () {
      var list = []
      this.ryImgsCopy.forEach((item) => {
        if (item.name.toLowerCase().indexOf(this.searchStr.toLowerCase()) !== -1) {
          list.push(item)
        }
      })
      this.ryImgs = list
      this.pageNum = 1
      this.pageSet()
    },
    clearSearch () {
      this.searchStr = ''
      this.rySearch()
    },
    pageSet () {
      this.total = this.ryImgs.length
      this.pageList = this.ryImgs.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize)
    },
    pageChange (val) {
      this.pageNum = val
      this.pageSet()
    },
    pagePrev () {
      this.pageNum--
      this.pageSet()
    },
    pageNext () {
      this.pageNum++
      this.pageSet()
    }
  }
}
</script>

<style scoped>
.main{
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 10px;
}
.block {
  width: 52%;
  margin-left: 20px;
  margin-top: 10px;
  display: inline-block;
}
.yw-block {
  width: 1040px;
  margin-left: 10px;
  float: right;
}
.en-title {
  font-size: 25px;
  color: rgb(149, 158, 158);
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.text {
    font-size: 16px;
    width: 46%;
    float: left;
    padding-left: 8px;
  }
.item {
    margin-bottom: 18px;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both
}

.cpProfile {
  width: 1800px;
  height: 620px;
  display: inline-block;
  text-align: left;
  line-height: 30px;
}
.dpHis {
  width: 1800px;
  height: auto;
  display: inline-block;
  text-align: left;
  line-height: 26px;
  margin-top: 30px;
  margin-bottom: 50px;
}
.comp-ry {
  width: 1800px;
  height: 410px;
  display: inline-block;
  text-align: left;
  line-height: 26px;
  margin-top: 30px;
}
.comp-yw {
  width: 1800px;
  height: 730px;
  display: inline-block;
  text-align: left;
  line-height: 26px;
  margin-top: 30px;
}
.slogan {
  width: 425px;
}
/* 根据需要添加样式 */
.image-slider {
  width: 1300px;
  overflow: hidden;
}
.scroll-container {
  height: 285px; /* 请根据实际情况调整高度 */
}
.imgScroll {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
}
li {
  margin-right: 15px; /* 图片间的间距 */
}
img {
  width: 200px; /* 图片宽度，请按需调整 */
  height: 285px;
}
.image {
  width: 200px; /* 图片宽度，请按需调整 */
  height: 285px;
}
.product-card {
    width: 640px;
    margin-left: 20px;
    margin-bottom: 10px;
    font-size: 16px;
}
.demonstration {
    margin-top: 5px;
}
.btn-oem {
  position: absolute;
  margin-top: 589px;
  margin-left: -600px;
  border-color: rgba(0, 0, 0, 0);
  background-color: rgba(0, 0, 0, 0);
}
.btn-oem:hover{
  border: 2px solid rgb(64, 158, 255);
  background-color: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/introduction.vue